import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { TriviaRainModalComponent } from '@features/engagement/trivia/trivia-rain-modal/trivia-rain-modal.component';
import { TriviaRegularModalComponent } from '@features/engagement/trivia/trivia-regular-modal/trivia-regular-modal.component';

export function provideTriviaModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'TriviaRainModal', component: TriviaRainModalComponent, requiresAdmin: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'TriviaRegularModal', component: TriviaRegularModalComponent, requiresAdmin: true }, multi: true },
  ];
}
